<div class="kanban-search-bar">
  <mat-form-field appearance="outline" class="search-input">
    <mat-label>Search tasks </mat-label>
    <input matInput [formControl]="searchControl" placeholder="E.g., Jane" />
    <mat-icon matPrefix>search</mat-icon>
  </mat-form-field>
  <div class="avatar-list-container">
    @for (user of users$ | async; track user.id) {
      <button
        class="avatar-wrapper"
        [class.selected]="!!selectedUsers.value.includes(user.id)"
        [class.current]="currentUserId === user.id"
        (click)="selectUser(user.id)"
        [matTooltip]="user.email">
        {{ user.email[0] }}
      </button>
    }
  </div>
</div>

@for (task of tasks; track task.task_id) {
  <a [routerLink]="['.', { outlets: { 'task-details': [task.task_id] } }]" queryParamsHandling="preserve">
    <mat-card class="task-card" [class]="'priority-' + task.priority + '-border'">
      <div class="task-content">
        <div class="task-header">
          <span class="task-title">{{ task.name }}</span>
        </div>

        <div class="task-meta-top">
          <span class="status-badge">
            {{ task.status | kanbanId }}
          </span>
          @if (task.tags && task.tags.length > 0) {
            <div class="tag-list">
              @for (tag of task.tags; track tag) {
                <span class="task-tag">{{ tag }}</span>
              }
            </div>
          }
        </div>
      </div>
      @if (task.due_date) {
        <span class="due-date-chip" [class.expired]="task.due_date | isDueDateExpired">
          {{ task.due_date | date: 'MMM d' }}
        </span>
      }
      @if (task.assigned_to) {
        <div class="task-meta-bottom">
          {{ task.assigned_to.name }}
          <p [class.persona-avatar]="task.assigned_to.type === 'persona'" class="assignee-avatar">
            {{ task.assigned_to.type[0] | uppercase }}
          </p>
        </div>
      }
    </mat-card>
  </a>
}
<router-outlet name="task-details"></router-outlet>
